var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ServerError } from '../Error';
import * as authCommon from './Common';
import createProviders from './Providers';
import { createStorage } from './Storage';
import jwtDecode from 'jwt-decode';
var EMBEDDED_USER_AUTH_DATA_PARTS = 4;
var Auth = (function () {
    function Auth(client, rootUrl, options) {
        var _a;
        this.client = client;
        this.rootUrl = rootUrl;
        options = __assign({ codec: {
                accessToken: 'access_token',
                deviceId: 'device_id',
                refreshToken: 'refresh_token',
                userId: 'user_id',
            }, namespace: 'admin', storageType: 'localStorage' }, options);
        this.client = client;
        this.rootUrl = rootUrl;
        this.codec = options.codec;
        this.requestOrigin = options.requestOrigin;
        this.storage = (_a = options.storage) !== null && _a !== void 0 ? _a : createStorage({
            namespace: options.namespace,
            storageType: options.storageType,
        });
        this.providers = createProviders(this);
        var authObj = this._get();
        this.auth = authObj;
        this.authedId = authObj.userId;
        this.rt = this.storage.get(authCommon.REFRESH_TOKEN_KEY);
        return this;
    }
    Auth.prototype.provider = function (name) {
        if (!Object.prototype.hasOwnProperty.call(this.providers, name)) {
            throw new Error("Invalid auth provider specified: " + name);
        }
        return this.providers[name];
    };
    Auth.prototype.refreshToken = function () {
        var _this = this;
        return this.client.doSessionPost().then(function (json) { return _this.set(json); });
    };
    Auth.pageRootUrl = function () {
        return [window.location.protocol, '//', window.location.host, window.location.pathname].join('');
    };
    Auth.getCookie = function (name) {
        var splitCookies = document.cookie.split(' ');
        for (var i = 0; i < splitCookies.length; i++) {
            var cookie = splitCookies[i];
            var sepIdx = cookie.indexOf('=');
            var cookieName = cookie.substring(0, sepIdx);
            if (cookieName === name) {
                var cookieVal = cookie.substring(sepIdx + 1, cookie.length);
                if (cookieVal[cookieVal.length - 1] === ';') {
                    return cookieVal.substring(0, cookieVal.length - 1);
                }
                return cookieVal;
            }
        }
        return '';
    };
    Auth.prototype.handleCookie = function () {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            return;
        }
        if (!document.cookie) {
            return;
        }
        var uaCookie = Auth.getCookie(authCommon.USER_AUTH_COOKIE_NAME);
        if (!uaCookie) {
            return;
        }
        document.cookie = authCommon.USER_AUTH_COOKIE_NAME + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT;";
        var userAuth = this.unmarshallUserAuth(uaCookie);
        this.set(userAuth);
        window.history.replaceState(undefined, '', Auth.pageRootUrl());
    };
    Auth.prototype.clear = function () {
        this.auth = undefined;
        this.authedId = undefined;
        this.rt = undefined;
        this.storage.remove(authCommon.USER_AUTH_KEY);
        this.storage.remove(authCommon.REFRESH_TOKEN_KEY);
    };
    Auth.prototype.isAccessTokenExpired = function (withinSeconds) {
        if (withinSeconds === void 0) { withinSeconds = authCommon.DEFAULT_ACCESS_TOKEN_EXPIRE_WITHIN_SECS; }
        var token = this.getAccessToken();
        if (!token) {
            return false;
        }
        var decodedToken;
        try {
            decodedToken = jwtDecode(token);
        }
        catch (e) {
            return false;
        }
        if (!decodedToken) {
            return false;
        }
        return decodedToken.exp && Math.floor(Date.now() / 1000) >= decodedToken.exp - withinSeconds;
    };
    Auth.prototype.getAccessToken = function () {
        var _a;
        return (_a = this.auth) === null || _a === void 0 ? void 0 : _a.accessToken;
    };
    Auth.prototype.getRefreshToken = function () {
        return this.rt;
    };
    Auth.prototype.set = function (json) {
        if (!json) {
            return;
        }
        var newUserAuth = {};
        if (json[this.codec.refreshToken]) {
            this.rt = json[this.codec.refreshToken];
            delete json[this.codec.refreshToken];
            this.storage.set(authCommon.REFRESH_TOKEN_KEY, this.rt);
        }
        if (json[this.codec.accessToken]) {
            newUserAuth.accessToken = json[this.codec.accessToken];
        }
        if (json[this.codec.userId]) {
            newUserAuth.userId = json[this.codec.userId];
        }
        this.auth = __assign(__assign({}, (this.auth ? this.auth : {})), newUserAuth);
        this.authedId = this.auth.userId;
        this.storage.set(authCommon.USER_AUTH_KEY, JSON.stringify(this.auth));
    };
    Auth.prototype._get = function () {
        var data = this.storage.get(authCommon.USER_AUTH_KEY);
        if (!data) {
            return {};
        }
        try {
            return JSON.parse(data);
        }
        catch (e) {
            this.clear();
            throw new ServerError('Failure retrieving stored auth');
        }
    };
    Auth.prototype.unmarshallUserAuth = function (data) {
        var _a;
        var parts = data.split('$');
        if (parts.length !== EMBEDDED_USER_AUTH_DATA_PARTS) {
            throw new RangeError("invalid user auth data provided: " + data);
        }
        return _a = {},
            _a[this.codec.accessToken] = parts[0],
            _a[this.codec.refreshToken] = parts[1],
            _a[this.codec.userId] = parts[2],
            _a;
    };
    return Auth;
}());
export default Auth;
//# sourceMappingURL=index.js.map